/**
 * @author      carlos.soto@zumper.com (Carlos J. Soto)
 * @copyright   Copyright (c) 2024, Zumper
 * @description Clear icon (X in circle)
 */

import * as React from 'react'

import clear from '../../../img/clear.svg'
import { ImgIconProps } from '../../../types'

export const Clear = ({ alt = 'clear', size = 18, ...props }: ImgIconProps) => (
  // biome-ignore lint/a11y/useAltText: It's already getting an alt attribute through the alt prop
  <img alt={alt} height={size} loading="lazy" src={clear} width={size} {...props} />
)
